<template>
  <div class="con-main">
    <div class="bzlm-nav">
      <div class="bzlm-nav-list" @click="comeback">返回上级</div>
      <div class="bzlm-nav-list" @click="bmgl">页面预览</div>
      <div class="bzlm-nav-list" @click="bqxq">本期详情</div>
      <div class="bzlm-nav-list2">选择期数</div>
      <div class="bzlm-nav-list2 bzlm-nav-list3">
        <el-cascader
        filterable
          placeholder="请选择期数"
          size="small"
          v-model="qsvalue"
          :options="qsoptions"
          @change="handleChange"
        />
      </div>

      <div class="bzlm-nav-sxq">
        <div class="bzlm-nav-sxq-l" @click="shangyiqi">上一期</div>
        <div class="bzlm-nav-sxq-l" @click="xiayiqi">下一期</div>
      </div>
    </div>
    <div class="bzlm">
      <!-- 图片 bqxqobj -->
      <div class="bzlm-img-main">
        <div class="bzlm-img-title">
          当前：{{ props.lanmuobj.year }}年 - 第{{
            props.lanmuobj.qs
          }}期（总第{{ props.lanmuobj.zqs }}期）
        </div>
        <div class="bzlm-img">
          <el-image
            :src="bzfm"
            :preview-src-list="srcList"
            style="width: 100%; height: 100%"
          ></el-image>
        </div>
      </div>

      <!-- 文章列表 -->
      <div class="bzlm-daodu">
        <div class="bzlm-bmdh-title2">
          <div class="bzlm-bmdh-title-list">
            <svg
              t="1688026062224"
              class="bzlm-bmdh-title-icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="12052"
              width="20"
              height="20"
            >
              <path
                d="M928 213.333333h-74.666667V96a53.393333 53.393333 0 0 0-53.333333-53.333333H96a53.393333 53.393333 0 0 0-53.333333 53.333333v704a53.393333 53.393333 0 0 0 53.333333 53.333333h117.333333v74.666667a53.393333 53.393333 0 0 0 53.333334 53.333333h661.333333a53.393333 53.393333 0 0 0 53.333333-53.333333V266.666667a53.393333 53.393333 0 0 0-53.333333-53.333334zM96 810.666667a10.666667 10.666667 0 0 1-10.666667-10.666667V96a10.666667 10.666667 0 0 1 10.666667-10.666667h704a10.666667 10.666667 0 0 1 10.666667 10.666667v704a10.666667 10.666667 0 0 1-10.666667 10.666667z m842.666667 117.333333a10.666667 10.666667 0 0 1-10.666667 10.666667H266.666667a10.666667 10.666667 0 0 1-10.666667-10.666667v-74.666667h544a53.393333 53.393333 0 0 0 53.333333-53.333333V256h74.666667a10.666667 10.666667 0 0 1 10.666667 10.666667z m-256-309.333333a21.333333 21.333333 0 0 1-21.333334 21.333333H234.666667a21.333333 21.333333 0 0 1 0-42.666667h426.666666a21.333333 21.333333 0 0 1 21.333334 21.333334z m0-213.333334a21.333333 21.333333 0 0 1-21.333334 21.333334H533.333333a21.333333 21.333333 0 0 1 0-42.666667h128a21.333333 21.333333 0 0 1 21.333334 21.333333z m0-170.666666a21.333333 21.333333 0 0 1-21.333334 21.333333H533.333333a21.333333 21.333333 0 0 1 0-42.666667h128a21.333333 21.333333 0 0 1 21.333334 21.333334zM213.333333 448V234.666667a21.333333 21.333333 0 0 1 38-13.333334l132.666667 165.853334V234.666667a21.333333 21.333333 0 0 1 42.666667 0v213.333333a21.333333 21.333333 0 0 1-38 13.333333L256 295.48V448a21.333333 21.333333 0 0 1-42.666667 0z"
                fill="#A80000"
                p-id="12053"
              ></path>
            </svg>
            本期文章列表
          </div>
        </div>
        <div class="bzlm-bmdh-xz-con">
          <div class="bzlm-bmdh-con">
            <div
              class="bzlm-daodu-con-list"
              v-for="(item, key) in wenzhangall"
              :key="key"
            >
              <svg
                t="1688090843468"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="18313"
                width="20"
                height="20"
              >
                <path
                  d="M512 192c212.064 0 320 107.936 320 320s-107.936 320-320 320S192 724.064 192 512 299.936 192 512 192z m37.024 216.128a32 32 0 0 0 0 45.248l22.912 22.944h-184.288a32 32 0 1 0 0 64h187.52l-26.144 26.176a32 32 0 0 0 45.248 45.28l67.904-67.904a32 32 0 0 0 7.296-33.92 32 32 0 0 0-7.296-33.952l-67.904-67.872a32 32 0 0 0-45.248 0z"
                  fill="#FA6400"
                  p-id="18314"
                ></path>
                <path
                  d="M512 32C191.936 32 32 191.936 32 512c0 320.064 159.936 480 480 480 320.064 0 480-159.936 480-480C992 191.936 832.064 32 512 32z m0 64c284.736 0 416 131.264 416 416s-131.264 416-416 416S96 796.736 96 512 227.264 96 512 96z"
                  fill="#E02020"
                  fill-opacity=".148"
                  p-id="18315"
                ></path>
              </svg>
              <span
                class="bzlm-daodu-con-list-link"
                @click="clickwenzhang(item.Id, key)"
              >
                <span class="bzlm-daodu-con-list-link-wz">{{
                  item.title
                }}</span>
                <span class="bzlm-daodu-con-list-link-writer">{{
                  item.writer
                }}</span>
              </span>
            </div>
          </div>
          <div class="bzlm-bmdh-fy">
            <el-pagination
              small
              background
              layout="prev, pager, next"
              :total="total"
              :default-page-size="pagesize"
              @current-change="fenye"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { get } from "@/utils/index";
import { ElMessage } from "element-plus";
import { reactive, getCurrentInstance, ref, defineProps } from "vue";
const { proxy } = getCurrentInstance();
// router
import { useRouter } from "vue-router";
const router = useRouter();
// vuex
import { useStore } from "vuex";
const store = useStore();
// 父组件传递值
const props = defineProps({
  lanmuobj: {
    type: Object,
  },
});
// console.log(props.lanmuobj);
// 当前期数索引
let dqqsindex = ref(0);
// 类型
let contype = store.state.contype;
// 全部期数
let allqishuList = reactive([]);
// 选择期数
let qsvalue = ref("");
let qsoptions = reactive([]);
// 本期id
let benqiId = ref("");
// 本版图片
let bzfm = ref("");
// 预览图片地址
let srcList = reactive([]);
// 全部文章
let wenzhangall = reactive([]);
// 分页
let page = ref(1);
let pagesize = ref(15);
let total = ref(0);
// 根据栏目生成需要跳转的路径前缀
let urlqz = ref("");
switch (router.currentRoute.value.query.navid) {
  case "1":
    urlqz.value = "/jyyj";
    break;
  case "2":
    urlqz.value = "/kjts";
    break;
  case "3":
    urlqz.value = "/jkkp";
    break;
  case "4":
    urlqz.value = "/szyt";
    break;
  case "5":
    urlqz.value = "/myrh";
    break;
  case "6":
    urlqz.value = "/xljj";
    break;
  case "7":
    urlqz.value = "/xxfz";
    break;
  default:
    urlqz.value = "";
    break;
}

// 获取全部期数
const getqsall = () => {
  get("/api/NewsPaper/GetAllQishu", {
    type: contype.filter((e) => {
      return e.name === "期刊";
    })[0].value,
    id: router.currentRoute.value.query.bzid,
  }).then((res) => {
    // 保存全部期数
    allqishuList.push(...res.data);
    // 获取最新一期内容
    // benqiId.value=allqishuList[dqqsindex.value].Id
    // 获取参数的期数id
    benqiId.value = router.currentRoute.value.query.id;
    // 根据当前期数id找出其在全部期数中的索引
    allqishuList.forEach((e, i) => {
      if (e.Id === benqiId.value) {
        dqqsindex.value = i;
      }
    });

    getbqxq(benqiId.value);
    // 渲染期数下拉框 筛选出年份 通过年份生成数组
    let tempval = ""; //临时年份
    let yearsz = []; //年份数组
    allqishuList.forEach((e) => {
      //筛选出数组中年份
      if (tempval == "") {
        tempval = e.year;
        yearsz.push(e.year);
      } else {
        if (tempval != e.year) {
          tempval = e.year;
          yearsz.push(e.year);
        } else {
          return true;
        }
      }
    });
    qsoptions.length = 0; //重置select
    yearsz.forEach((e, i) => {
      //通过年份生成数组
      qsoptions.push({
        value: e,
        label: `${e}年`,
        children: [],
      });
      let childrenval = [];
      allqishuList.forEach((ele) => {
        if (e == ele.year) {
          // 存在小期数添加，不存在为""不添加
          if (ele.smallqs != "") {
            childrenval.push({
              value: ele.Id,
              label: `第${ele.qs}-${ele.smallqs}期`,
            });
          } else {
            childrenval.push({
              value: ele.Id,
              label: `第${ele.qs}期`,
            });
          }
        }
      });
      qsoptions[i].children = childrenval;
    });
  });
};
setTimeout(() => {
  // 显示本期封面
  bzfm.value = `${proxy.$imgurl}${props.lanmuobj.fm}`;
  getqsall();
}, 100);

// 获取本期全部文章
const getbqxq = (qsid) => {
  // 保存该期数下的全部文章
  get("/api/NewsPaper/GetAllArticlePage", {
    qsid: qsid,
    lmid: 0,
    page: page.value,
    pagesize: pagesize.value,
  }).then((result) => {
    // console.log(result)
    // 清零重新赋值
    wenzhangall.length = 0;
    wenzhangall.push(...result.data);
    wenzhangall.map((e) => {
      return (e.sybm = e.sybm.split(","));
    });
    total.value = result.total;
    // 本期封面
    srcList.length = 0;
    srcList.push(`${proxy.$imgurl}${props.lanmuobj.fm}`);
  });
};

// 分页
const fenye = (value) => {
  // console.log(value)
  page.value = value;
  getbqxq(benqiId.value);
};

// 获取文章详情
const clickwenzhang = (wzid, index) => {
  router.push({
    path: "/jyyj/wzxq", //文章详情公用页面
    query: {
      wzid: wzid, //文章id
    },
  });
};

// 选择期数
const handleChange = (value) => {
  router.push({
    path: urlqz.value + "/index",
    query: {
      navid: router.currentRoute.value.query.navid, //栏目id
      id: value[1], //当前期数id
      bzid: router.currentRoute.value.query.bzid, //报纸id  用于获取全部期数
    },
  });
};

// 上一期
const shangyiqi = () => {
  if (allqishuList[dqqsindex.value - 1]) {
    router.push({
      path: urlqz.value + "/index",
      query: {
        navid: router.currentRoute.value.query.navid, //栏目id
        id: allqishuList[dqqsindex.value - 1].Id, //当前期数id
        bzid: router.currentRoute.value.query.bzid, //报纸id  用于获取全部期数
      },
    });
  } else {
    ElMessage({
      message: "已经是第一期了",
      type: "info",
    });
    return false;
  }
};

// 下一期
const xiayiqi = () => {
  if (allqishuList[dqqsindex.value + 1]) {
    router.push({
      path: urlqz.value + "/index",
      query: {
        navid: router.currentRoute.value.query.navid, //栏目id
        id: allqishuList[dqqsindex.value + 1].Id, //当前期数id
        bzid: router.currentRoute.value.query.bzid, //报纸id  用于获取全部期数
      },
    });
  } else {
    ElMessage({
      message: "已经是最新一期了",
      type: "info",
    });
    return false;
  }
};

// 跳转
const comeback = () => {
  router.push({
    path: urlqz.value + "/list",
    query: {
      idx: store.state.navindex,
      dflid: router.currentRoute.value.query.navid, //大分类id,
    },
  });
};
// 版面概览
const bmgl = () => {
  router.push({
    path: urlqz.value + "/bmgl",
    query: {
      navid: router.currentRoute.value.query.navid, //大分类id
      id: router.currentRoute.value.query.id, //当前期数id
      bzid: router.currentRoute.value.query.bzid, //报纸id  用于获取全部期数
    },
  });
};
// 本期详情
const bqxq = () => {
  router.push({
    path: urlqz.value + "/index",
    query: {
      navid: router.currentRoute.value.query.navid, //大分类id
      id: router.currentRoute.value.query.id, //当前期数id
      bzid: router.currentRoute.value.query.bzid, //报纸id  用于获取全部期数
    },
  });
};
</script>

<style scoped>
::v-deep .select-trigger {
  width: 120px;
}

.con-main {
  width: 1200px;
  margin: auto;
  margin-bottom: 30px;
}
.con-main:after {
  content: "";
  display: table;
  clear: both;
}
.jkrb-banner {
  width: 100%;
  height: 163px;
  text-align: center;
}
.bzlm {
  margin-top: 20px;
}
.bzlm-nav {
  width: 100%;
  height: 40px;
  background: #fafafa;
  border-top: 5px solid #ddd;
  border-bottom: 5px solid #ddd;
  margin-top: 20px;
}
.bzlm-nav-list {
  float: left;
  margin: 10px 30px 0 30px;
  cursor: pointer;
}
.bzlm-nav-list:hover {
  color: #2fadc6;
}
.bzlm-nav-list2 {
  float: left;
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 30px;
}
.bzlm-nav-list3 {
  margin-left: 10px;
}
.bzlm-nav-list2-span {
  font-size: 14px;
}
.bzlm-nav-sxq {
  float: right;
  margin-right: 30px;
  width: 120px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bzlm-nav-sxq-l {
  cursor: pointer;
}
.bzlm:after {
  content: "";
  display: table;
  clear: both;
}
.bzlm-xiangqing {
  width: 680px;
  height: 730px;
  float: left;
  box-sizing: border-box;
  border: 1px solid #ccc;
  margin-left: 20px;
}
.bzlm-xiangqing-nav {
  width: 100%;
  height: 30px;
  border-bottom: 1px solid #ccc;
  font-size: 14px;
  padding: 0 20px;
  background: #fafafa;
  box-sizing: border-box;
}
.bzlm-xiangqing-nav-list {
  width: 80px;
  height: 30px;
  float: left;
  display: flex;
  align-items: center;
  margin-right: 30px;
  cursor: pointer;
}
.bzlm-xiangqing-nav-list2 {
  width: 60px;
  height: 30px;
  float: left;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.bzlm-xiangqing-nav-list > .icon {
  margin-right: 5px;
}
.bzlm-xiangqing-con {
  width: 100%;
  height: calc(100% - 30px);
  overflow-y: scroll;
  font-size: 1em;
  padding: 20px;
  box-sizing: border-box;
}
.bzlm-xiangqing-con-title {
  font-size: 1.4em;
  text-align: center;
}
.bzlm-xiangqing-con-subtitle {
  font-size: 0.8em;
  text-align: center;
  color: #999;
  padding: 10px 0 20px 0;
}
.bzlm-xiangqing-con-text {
  font-size: 1em;
  text-align: justify;
  line-height: 1.5em;
  margin-bottom: 10px;
}

.bzlm-bmdh {
  width: 280px;
  height: 730px;
  float: left;
  box-sizing: border-box;
  border: 1px solid #ccc;
  margin-left: 20px;
}
.bzlm-bmdh-title {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  font-weight: bold;
  box-sizing: border-box;
  border-bottom: 1px solid #ccc;
}
.bzlm-bmdh-title2 {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  box-sizing: border-box;
  border-bottom: 1px solid #ccc;
}
.bzlm-bmdh-title-icon {
  margin: 0 10px 0 10px;
}
.bzlm-bmdh-title-list {
  display: flex;
  align-items: center;
  height: 40px;
}
.bzlm-bmdh-title-list2 {
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 10px;
}
.bzlm-bmdh-title-lists {
  margin-left: 10px;
  cursor: pointer;
}
.bzlm-bmdh-con {
  padding: 10px;
  height: 650px;
  box-sizing: border-box;
}
.bzlm-bmdh-con-list {
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  border-bottom: 1px dashed #ccc;
  box-sizing: border-box;
  height: 30px;
  align-items: center;
}
.bzlm-bmdh-con-list-link {
  cursor: pointer;
  text-overflow: ellipsis; /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap; /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden; /*超出部分隐藏*/
}
.bzlm-bmdh-con-list-link:hover {
  color: #2fadc6;
}
.bzlm-daodu-con-list {
  font-size: 14px;
  border-bottom: 1px dashed #ccc;
  box-sizing: border-box;
  height: 40px;
  display: flex;
  align-items: center;
}
.bzlm-daodu-con-list > .icon {
  float: left;
}
.bzlm-daodu-con-list-link {
  display: block;
  width: calc(100% - 30px);
  float: left;
  padding-left: 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bzlm-daodu-con-list-link:hover {
  color: #2fadc6;
}
.bzlm-img-main {
  float: left;
  width: 500px;
  height: 730px;
}
.bzlm-img-title {
  width: 100%;
  height: 30px;
  float: left;
  padding: 0 20px;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  background: #fafafa;
  box-sizing: border-box;
}
.bzlm-img {
  width: 100%;
  height: 690px;
  float: left;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #999;
  box-shadow: 0 0 10px #ccc;
}
.bzlm-daodu {
  width: 680px;
  height: 730px;
  float: left;
  box-sizing: border-box;
  border: 1px solid #ccc;
  margin-left: 20px;
}
.bzlm-bmdh-fy {
  padding: 0 10px 10px 10px;
}
.bzlm-daodu-con-list-link-wz {
  width: 470px;
  display: block;
  text-overflow: ellipsis; /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap; /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden; /*超出部分隐藏*/
}
.bzlm-daodu-con-list-link-writer {
  width: 138px;
  display: block;
  text-align: right;
  text-overflow: ellipsis; /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap; /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden; /*超出部分隐藏*/
}
</style>
